// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"542":"ceb6c834","824":"d9d1bdc1"}[chunkId] + ".css";
};